import { RootState } from '@src/store/store'
import { AddressStateType } from '@src/store/ducks/address/reducer'

export const selectAddress = (state: RootState): AddressStateType => state.address
export const selectMovingNewAddress = (state: RootState) => selectAddress(state).addresses
export const selectSuccessMoving = (state: RootState) => selectAddress(state).successInfoConnect
export const selectAddressIsLoadingCheck = (state: RootState) => selectAddress(state).isLoadingCheck
export const selectAddressIsLoadingChange = (state: RootState) => selectAddress(state).isLoadingChange
export const selectAddressIsSuccessChange = (state: RootState) => selectAddress(state).isSuccessChange
